import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store/store';
import { ChakraProvider, createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';
import '../css/forms-app.css';
import '../css/react-datepicker.css';
import * as Sentry from '@sentry/react';
import App from './App';

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV === 'production') {
	Sentry.init({
		dsn: 'https://679fa4e709d1a690498ca4eedb68c575@o4510262207119360.ingest.us.sentry.io/4510273496481793',
		sendDefaultPii: true,
		integrations: [Sentry.browserTracingIntegration()],

		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		// We recommend adjusting this value in production
		tracesSampleRate: 1.0
	});
}

const root = createRoot(document.getElementById('forms-app-root'), {
	// Callback called when an error is thrown and not caught by an ErrorBoundary.
	onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
		console.warn('Uncaught error', error, errorInfo.componentStack);
	}),
	// Callback called when React catches an error in an ErrorBoundary.
	onCaughtError: Sentry.reactErrorHandler(),
	// Callback called when React automatically recovers from errors.
	onRecoverableError: Sentry.reactErrorHandler()
});

const config = defineConfig({
	preflight: true,
	globalCss: {
		'body, blockquote, dl, dd, h1, h2, h3, h4, h5, h6, hr, figure, p, pre': {
			margin: '0 !important'
		},
		'h1, h2, h3, h4, h5, h6, h6': {
			fontWeight: '700 !important'
		},
		'nav ul li': {
			listStyle: 'none'
		},
		'.chakra-field__root .chakra-stack': {
			width: '100%'
		},
		'.safety-database-results *': {
			cursor: 'pointer'
		}
	}
});

const system = createSystem(defaultConfig, config);

root.render(
	<Provider store={store}>
		<React.StrictMode>
			<ChakraProvider value={system}>
				<PersistGate persistor={persistor}>
					<App />
				</PersistGate>
			</ChakraProvider>
		</React.StrictMode>
	</Provider>
);
